import React from 'react';
import Grid, { GridProps } from '@material-ui/core/Grid';

const SupportTileGrid: React.FC<GridProps> = ({ children, ...rest }) => {
  return (
    <Grid container spacing={2} {...rest}>
      {children}
    </Grid>
  );
};

export default SupportTileGrid;
